import { render, staticRenderFns } from "./ImagenConfig.vue?vue&type=template&id=8f03fbd2&scoped=true"
import script from "./ImagenConfig.vue?vue&type=script&lang=js"
export * from "./ImagenConfig.vue?vue&type=script&lang=js"
import style0 from "./ImagenConfig.vue?vue&type=style&index=0&id=8f03fbd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f03fbd2",
  null
  
)

export default component.exports